import './shared/typography.scss';
import './shared/navigation.scss';
import './shared/card.scss';
import './welcome/styles.scss';
import Card from './shared/card';
Card();